import { useState, useEffect } from 'react';

/**
 * Hook to check if PWA features should be enabled on this device.
 * Returns false if the user has disabled PWA via the reset tool.
 */
export function usePwaEnabled(): boolean {
  const [isEnabled, setIsEnabled] = useState(() => {
    // Check localStorage flag
    if (typeof window !== 'undefined') {
      const disabled = localStorage.getItem('pwa-disabled') === '1';
      // Also check URL param for immediate effect
      const urlParams = new URLSearchParams(window.location.search);
      const pwaOff = urlParams.get('pwa') === 'off';
      return !disabled && !pwaOff;
    }
    return true;
  });

  useEffect(() => {
    // Re-check on mount in case localStorage changed
    const disabled = localStorage.getItem('pwa-disabled') === '1';
    const urlParams = new URLSearchParams(window.location.search);
    const pwaOff = urlParams.get('pwa') === 'off';
    setIsEnabled(!disabled && !pwaOff);
  }, []);

  return isEnabled;
}

/**
 * Re-enable PWA on this device (clears the disabled flag).
 */
export function enablePwa(): void {
  localStorage.removeItem('pwa-disabled');
  // Reload to allow SW to register
  window.location.reload();
}

/**
 * Check if PWA is currently disabled (synchronous check for non-React contexts).
 */
export function isPwaDisabled(): boolean {
  if (typeof window === 'undefined') return false;
  const disabled = localStorage.getItem('pwa-disabled') === '1';
  const urlParams = new URLSearchParams(window.location.search);
  const pwaOff = urlParams.get('pwa') === 'off';
  return disabled || pwaOff;
}
